<template>
  <div id="content">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <div class="inner">
      <add-button v-if="$_createActionAllowed" :title="'Přidat business model' | translate" route-name="businessModelsNew"></add-button>
      <h1 v-translate>Business modely</h1>
    </div>
    <div class="inner_white">
      <div class="filter">
        <div class="field_left">
          <search-input input-class="search" v-model="formFields.search"></search-input>
        </div>
        <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset"
           :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
      </div>
      <div class="scroll-wrapper">
        <div class="table_overflow" id="contentBox" data-table-id="business-models-list">
          <table class="vypis vypis_detail">
            <thead>
            <tr v-if="entities.length > 0">
              <th class="no_padding drag_drop"></th>
              <th class="no_padding checkbox"/>
              <sorting-table-title
                  v-for="title in businessModelTableTitles"
                  :key="title.key"
                  :column="title.column"
                  :sort="getActiveSort(title.column)"
                  @changeSorting="changeSorting"
              >{{ title.name }}
              </sorting-table-title>
              <th class="no_padding edit"></th>
            </tr>
            </thead>

            <business-model-row
                v-for="entity in entities"
                :entity="entity"
                :key="entity.id"
                @deleteBusinessModel="deleteEntity"
                :selectedEntities="selectedEntities"
                @input="select"
                :ref="'business-row-ref-'+entity.id"
            ></business-model-row>
          <tr v-if="entities.length === 0">
               <td colspan="8">{{ $gettext('Nebyly nalezeny žádné business modely.') }}</td>
          </tr>
          </table>
        </div>
      </div>
      <list-action-line
          :entities="entities"
          :offset="formFields.offset"
          :limit="formFields.limit"
          :total-count="totalCount"
          table-id="business-models-list"
          @limit="setLimit"
          @offset="setOffset"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          @select-all="toggleSelectAll"
          @run-multiple-action="runMultipleAction"
          ref="action_line"
      ></list-action-line>
    </div>
  </div>
</template>

<script>
import listActions from "@/components/mixins/list-actions"
import BusinessModelRow from "./BusinessModelRow";

export default {
  name: "BusinessModels",
  components: {
    BusinessModelRow
  },
  mixins: [listActions],
  data() {
    return {
      moduleName: 'businessModels',
      entitiesKey: 'business_models',
      formFields: {
        sort: {
          column: 'sName',
          direction: 'desc',
        }
      }
    }
  },
  created(BusinessModelService) {
    this.entityService = BusinessModelService
    this.createdInit()
  },
  computed: {
    businessModelTableTitles() {
      return [
        {key: 1, name: this.$gettext('Název modelu'), column: 'sName'},
        {key: 2, name: this.$gettext('Počet operátorů'), column: 'sOperatorsCount'},
        {key: 3, name: this.$gettext('Počet služeb'), column: 'sServicesCount'},
        {key: 4, name: this.$gettext('Počet balíčků'), column: 'sChannelPackagesCount'},
        {key: 5, name: this.$gettext('Vytvořeno'), column: 'sDateCreated'},
        {key: 6, name: this.$gettext('Upraveno'), column: 'sDateUpdated'},
      ]
    },
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
      ]
    },
    csvHeaders(){
      let headers = this.getCsvHeaderFromSortingTableTitle(this.businessModelTableTitles);
      headers.operators_count.callback = entity => { return entity.operators.length; };
      headers.services_count.callback = entity => { return entity.services.length; };
      headers.channel_packages_count.callback = entity => { return entity.channel_packages.length; };

      return headers;
    },
  },
  methods: {
    _processListErrorMessage(error) {
      let errorMessage = null;

      this._.forEach(error['validation_errors'], function (message) {
        if (message === "Unable to delete business model assigned to channel package.") {
          errorMessage = this.$gettext("Business model nelze smazat - existují balíčky kanálů s tímto modelem.");
        } else if (message === "Unable to delete business model assigned to operator.") {
          errorMessage = this.$gettext("Business model nelze smazat - je přiřazen operátorům.");
        } else if (message === "Unable to delete business model assigned to services.") {
            errorMessage = this.$gettext("Business model nelze smazat - je přiřazen službám.");
        } else {
          errorMessage = message;
        }
      }.bind(this))

      return errorMessage || error['error_message'];
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/businessModels/BusinessModelList.vue